class OpenLoginModal extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      e.target.dispatchEvent(new CustomEvent('login-modal:open', { bubbles: true }));
    });
  }

  connectedCallback() {

  }

  disconnectedCallback() {

  }
}

if (!customElements.get("open-login-modal")) {
  customElements.define("open-login-modal", OpenLoginModal);
}
